var React = require('react');

function Q (props) {
    return React.createElement("svg",props,React.createElement("text",{"fillRule":"evenodd","fontFamily":"BuenosAires-Regular, Buenos Aires","fontSize":"24","letterSpacing":"-.28","transform":"translate(-1 -5)"},React.createElement("tspan",{"x":"0","y":"23"},"Q.")));
}

Q.defaultProps = {"width":"22","height":"23","viewBox":"0 0 22 23"};

module.exports = Q;

Q.default = Q;
